function camelize(key: string): string {
  return key.replace(/^([A-Z])|[\s-_]+(\w)/g, function( _, p1: string, p2: string) {
    if (p2) return p2.toUpperCase();
      return p1.toLowerCase();
  });
}

function decamelize(key: string, separator = '_'){
	return key
        .replace(/([a-z\d])([A-Z])/g, '$1' + separator + '$2')
        .replace(/([A-Z]+)([A-Z][a-z\d]+)/g, '$1' + separator + '$2')
        .toLowerCase();
}

const transformObject = (transformFunction: (key: string) => string) =>
  (object: Record<string, unknown> | Array<unknown>): Record<string, unknown> | Array<unknown> | null => {
    if (object === null) {
      return null
    }
    if (Array.isArray(object)) {
      return (object).map(
        (item: unknown) => (typeof item === 'object' ? transformObject(transformFunction)(item as Record<string, unknown>) : item),
      );
    }
    return Object.keys(object)
      .reduce(
        (acc: Record<string, unknown>, key: string) => ({
            ...acc,
            [transformFunction(key)]: (typeof object[key] === 'object' ? transformObject(transformFunction)(object[key] as Record<string, unknown>) : object[key] ?? undefined),
          }),
          {},
      );
  }

export const camelizeObject = transformObject(camelize);
export const decamelizeObject = transformObject(decamelize);
